export enum PeppolConnectionStatus {
  None = 'None',
  Created = 'Created',
  KycDone = 'KycDone',
  Verified = 'Verified',
  Active = 'Active',
}

export type PeppolEnrollmentState =
  | 'loading'
  | 'enrolled'
  | 'unenrolled'
  | 'error';

export interface PeppolNotificationEmails {
  taxDoc: string | null;
  otherDocs: string | null;
  outgoingStatus: string | null;
}

export enum PeppolConnectionMode {
  SendAndReceive = 'All',
  SendOnly = 'SendingOnly',
}

export interface PeppolParticipant {
  ic: string | null;
  vat: string | null;
  localVat: string | null;
  isKycVerified: boolean;
  isLegalVerified: boolean;
  isVerified: boolean;
  scope: PeppolConnectionMode;
}

export interface PeppolConnection {
  status: PeppolConnectionStatus;
  peppolId: string | null;
  participant: PeppolParticipant;
}
